// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import type { Location } from 'react-router';
import {
  pushFlashMessage,
  clearFlashMessages
} from '../redux/main/actions/flashMessages';

type Props = {
  flashMessages: Array<FlashMessageType>,
  pushFlashMessage: Function,
  clearFlashMessages: Function,
  location: Location
};

class SetFlashMessages extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // clear flash messages on page navigation
      this.props.clearFlashMessages();
    }

    if (
      prevProps.location.pathname !== this.props.location.pathname ||
      prevProps.location.state !== this.props.location.state
    ) {
      // load new flash message from router state
      const flashMessage =
        this.props.location.state && this.props.location.state.flashMessage;
      if (flashMessage) {
        this.props.pushFlashMessage(flashMessage, true);
      }
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = ({ flashMessages }) => ({ flashMessages });

export default withRouter(
  connect(
    mapStateToProps,
    {
      pushFlashMessage,
      clearFlashMessages
    }
  )(SetFlashMessages)
);
